import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExceptionTrackingService } from '@com-delta-idp/mnx-utils';
import {
  EXCEPTION_CATEGORY_ENUM,
  IExceptionMetadata,
  LoginAuthWithCredentials,
  LoginAuthWithCredentialsParams,
  OauthAEMConfig,
  PostWithCredentials
} from '../../../models';
import { UtilService } from '../../util-service/util-service';

const fileName = 'PostWithFingerPrintService';

@Injectable({
  providedIn: 'root'
})
export class PostWithFingerPrintService {
  loginAuthHeaderForFingerprint = new HttpHeaders({
    'Content-Type': 'application/vnd.pingidentity.submitDeviceInformation+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  });

  constructor(
    private utils: UtilService,
    private exceptionTracking: ExceptionTrackingService
  ) {}

  async postWithFingerPrint(
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Promise<LoginAuthWithCredentials> {
    let requestPayload: PostWithCredentials = {};

    try {
      const uniqueIdentifier = this.utils.generateUniqueIdentifier();
      const encryptedTokenStored = this.utils.getLocalStorageValue('encyToken');
      const uniqueIdentifierStored = this.utils.getLocalStorageValue('uid');

      if (encryptedTokenStored && uniqueIdentifierStored) {
        requestPayload = {
          fingerprint: uniqueIdentifierStored,
          encryptedToken: encryptedTokenStored
        };
      } else {
        requestPayload = {
          fingerprint: uniqueIdentifier
        };
      }

      const loginAuthWithCredentialsParams: LoginAuthWithCredentialsParams = {
        flowId: flowIdValue,
        oauthConfig: authConfig
      };
      return await this.utils.loginAuthWithCredResponse(
        loginAuthWithCredentialsParams,
        requestPayload,
        this.loginAuthHeaderForFingerprint
      );
    } catch (exception) {
      const exceptionMetadata: IExceptionMetadata = {
        fileName,
        methodName: 'PostWithFingerPrint',
        exceptionCategory: EXCEPTION_CATEGORY_ENUM.JS_CATCH_BLOCK,
        exceptionMessage:
          'Exception caught while calling PostWithFingerPrintService'
      };
      const exceptionStr = exception as string;
      this.exceptionTracking.track(exceptionStr, exceptionMetadata);
      return exception as LoginAuthWithCredentials;
    }
  }
}
